import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DateInput from "../../../../components/inputs/dateInput";
import TextInput from "../../../../components/inputs/textInput";
import {
  handleAllInvoice,
  resetAllSummeryData,
} from "../../../../redux/actoin";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import { toIsoString } from "../../../../scripts/functions";

const Details = ({ data, reRender }) => {
  var currentDate = new Date();
  const [date, setDate] = useState(toIsoString(currentDate));
  const [getInvoiceIntSellDefaultValue, setGetInvoiceIntSellDefaultValue] =
    useState("");

  const [loading, setLoading] = useState({
    copy: false,
    create: false,
    delete: false,
    update: false,
  });
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [removeConfirm, setRemoveConfirm] = useState(false);
  const AllInvoice = useSelector((state) => state.AllInvoice);

  const navigate = useNavigate();
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const dispatch = useDispatch();
  const handleCopy = () => {
    setLoading({ copy: true });
    axiosInstance
      .post(
        API.int.copy,
        {
          guidRecNo: data?.guidRecNo,
          chSaleSoftID: getInvoiceIntSellDefaultValue,
          dInvoiceDate: date,
          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          dispatch(resetAllSummeryData());

          navigate(`/sell/invoice/${res.data.data}`);
        } else {
          toast.error(res.data.message);
        }
        setLoading({ copy: false });
      })
      .catch((err) => {
        setLoading({ copy: false });
      });
  };
  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(API.int.default + `?guidStateRecNo=${company?.guidRecNo}`, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setGetInvoiceIntSellDefaultValue(res?.data?.data?.chSaleSoftID);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  const handleCreate = () => {
    setLoading({ delete: true });
    axiosInstance
      .post(
        API.int.send,
        {
          guidRecNo: data?.guidRecNo,
          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          dispatch(resetAllSummeryData());

          reRender();
        } else {
          toast.error(res.data.message);
        }
        setLoading({ delete: false });
      })
      .catch((err) => {
        setLoading({ delete: false });
      });
  };
  const handleUpdate = () => {
    setLoading({ update: true });
    axiosInstance
      .post(
        API.int.edit,
        {
          guidRecNo: data?.guidRecNo,
          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          dispatch(resetAllSummeryData());

          navigate(`/sell/invoice/${res.data.data}`);
        } else {
          toast.error(res.data.message);
        }
        setLoading({ update: false });
      })
      .catch((err) => {
        setLoading({ update: false });
      });
  };
  const handleDelete = () => {
    setLoading({ delete: true });
    axiosInstance
      .post(
        API.int.cancel,
        {
          guidRecNo: data?.guidRecNo,
          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          dispatch(resetAllSummeryData());
          navigate(`/sell/invoice/`);
        } else {
          toast.error(res.data.message);
        }
        setLoading({ delete: false });
      })
      .catch((err) => {
        setLoading({ delete: false });
      });
  };
  const closeCopy = () => {
    setOpen3(false);
    /*     setGetInvoiceIntSellDefaultValue("");
     */
    setDate(toIsoString(currentDate));
  };
  const removeHandle = () => {
    setLoading({ loadingRemove: true });
    axiosInstance
      .delete(
        API.int.remove,

        {
          data: {
            guidRecNo: data?.guidRecNo,
            guidStateRecNo: company?.guidRecNo,
          },
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          var temp = [...AllInvoice.invoices?.invoices];
          temp = temp.filter((item) => item.guidRecNo !== data?.guidRecNo);
          dispatch(
            handleAllInvoice({
              ...AllInvoice.invoices,
              invoices: temp,
            })
          );
          dispatch(resetAllSummeryData());
          navigate(`/sell/invoice/`);
        } else {
          toast.error(res.data.message);
        }
        setLoading({ loadingRemove: false });
      })
      .catch((err) => {
        setLoading({ loadingRemove: false });
      });
  };
  return (
    <>
      {" "}
      <Paper
        sx={{ zIndex: 9, position: "relative" }}
        className="mx-3 my-5 border py-3 px-3 relative z-50"
        elevation={1}
      >
        <div className="md:flex flex-wrap  grid grid-cols-2 gap-4 items-center my-4 border-b pb-4 justify-center">
          {company?.chBusinessTypeCode !== "Restaurant" && (
            <Button
              sx={{
                fontSize: { xs: "11px !important", md: "1rem !important" },
              }}
              variant="contained"
              onClick={() => setOpen2(true)}
              disabled={loading.create}
            >
              {loading.create ? (
                <>
                  <CircularProgress size={20} />
                </>
              ) : (
                <> ارسال صورتحساب</>
              )}
            </Button>
          )}

          <Button
            sx={{ fontSize: { xs: "11px !important", md: "1rem !important" } }}
            variant="outlined"
            onClick={() => setOpen3(true)}
            disabled={loading.copy}
          >
            {loading.handleCopy ? (
              <>
                <CircularProgress size={20} />
              </>
            ) : (
              <> کپی صورتحساب</>
            )}
          </Button>
          {(data?.chLastWorkflowStepCode === "NoNeededAction" ||
            data?.chLastWorkflowStepCode === "Sended" ||
            data?.chLastWorkflowStepCode === "Rejected") &&
          data?.btLatest ? (
            <>
              {" "}
              <Button
                sx={{
                  fontSize: { xs: "11px !important", md: "1rem !important" },
                }}
                variant="outlined"
                onClick={() => setOpen4(true)}
                disabled={loading.update}
              >
                {loading.update ? (
                  <>
                    <CircularProgress size={20} />
                  </>
                ) : (
                  <> ایجاد صورتحساب اصلاحی</>
                )}
              </Button>
              <Button
                sx={{
                  fontSize: { xs: "11px !important", md: "1rem !important" },
                }}
                variant="outlined"
                color="error"
                onClick={() => setOpen(true)}
              >
                ایجاد صورتحساب ابطالی
              </Button>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex flex-col gap-4">
          <div className="sm:col-span-2  md:col-span-3  lg:col-span-4">
            <h2 className="text-base font-bold text-center mb-4 text-main">
              {" "}
              - اطلاعات ته جمع شامل -
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> قبل از تخفیف : </span>
            <span className="text- font-bold">
              {data?.moTotalPriceBeforeDiscount?.toLocaleString("en-US")}
            </span>
            <small className="text-xs">ریال</small>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> تخفیف : </span>
            <span className="text- font-bold">
              {data?.moTotalDiscount?.toLocaleString("en-US")}
            </span>
            <small className="text-xs">ریال</small>
          </div>{" "}
          {data.chInvoicePatternCode === "Jewelry" && (
            <>
              <div className="flex items-center gap-3">
                <span className="text-sm">
                  {" "}
                  جمع کل اجرت ، حق العمل و سود :{" "}
                </span>
                <span className="text-sm font-bold">
                  {data?.moConsProfitWorkPrice?.toLocaleString("en-US")}
                </span>
                <small className="text-xs">ریال</small>
              </div>
            </>
          )}
          <div className="flex items-center gap-3">
            <span className="text-sm"> مالیات : </span>
            <span className="text- font-bold">
              {data?.moTotalValueAddedPrice?.toLocaleString("en-US")}
            </span>
            <small className="text-xs">ریال</small>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> مجموع صورتحساب : </span>
            <span className="text- font-bold">
              {data?.moTotalBillPrice?.toLocaleString("en-US")}
            </span>
            <small className="text-xs">ریال</small>
          </div>
          <div className="sm:col-span-2  md:col-span-3 my-4  lg:col-span-4">
            <h2 className="text-base font-bold text-center text-main">
              {" "}
              - اطلاعات ارسال شامل-
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> موضوع : </span>
            <span className="text- font-bold">
              {data?.chInvoiceSubjectName}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> شماره مالیاتی : </span>
            <span className="text- font-bold">{data?.chTaxID}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> آخرین وضعیت : </span>
            <Box
              sx={{
                color: (theme) =>
                  data?.chLastWorkflowStepCode === "Sended"
                    ? "#81b1e7"
                    : data?.chLastWorkflowStepCode === "Failed"
                    ? "#ef7878"
                    : data?.chLastWorkflowStepCode === "Confirmed" ||
                      data?.chLastWorkflowStepCode === "BuyerConfirmed" ||
                      data?.chLastWorkflowStepCode === "SystemConfirmed"
                    ? "#33b151"
                    : data?.chLastWorkflowStepCode === "Rejected"
                    ? "#b1ab33"
                    : data?.chLastWorkflowStepCode === "NoNeededAction"
                    ? "#48fa73"
                    : data?.chLastWorkflowStepCode === "Canceled"
                    ? "#ed5c8a"
                    : theme.palette.mode === "dark"
                    ? "#fff"
                    : "#000",
              }}
              className="text- font-bold"
            >
              {data?.chLastWorkflowStepName}
            </Box>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> سریال داخلی : </span>
            <span className="text- font-bold">{data?.intTaxSerial}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm"> زمان ارسال : </span>
            <span className="text- font-bold">{data?.dtSendDateTime}</span>
          </div>
          {data?.chIrTaxID && (
            <div className="flex items-center gap-3">
              <span className="text-sm"> شماره مالیاتی مرجع : </span>
              <span className="text- font-bold">{data?.chIrTaxID}</span>
            </div>
          )}
        </div>

        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { md: "90%", xs: "90%" },
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              overflow: "auto",
              maxHeight: "95%",
              maxWidth: "400px",
            }}
          >
            <div className="py-4 px-3  mb-4 flex justify-between items-center border-b">
              <span className="text-2xl font-bold">ابطال</span>
              <div></div>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xl">
                {" "}
                آیا از ابطال این صورت حساب اطمینان دارید ؟‌
              </span>
            </div>
            <div className="flex col-span-2 justify-between items-center mt-5">
              <Button
                sx={{ width: "8rem" }}
                variant="contained"
                onClick={handleDelete}
                color="error"
                disabled={loading.delete}
              >
                {loading.delete ? (
                  <>
                    <CircularProgress size={20} />
                  </>
                ) : (
                  <>تایید</>
                )}
              </Button>{" "}
              <Button
                onClick={() => {
                  setOpen(false);
                }}
                sx={{ width: "8rem", background: "#ccc" }}
                variant="contained"
                color="inherit"
              >
                انصرف
              </Button>
            </div>
          </Box>
        </Modal>
        <Modal
          open={open2}
          onClose={() => {
            setOpen2(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { md: "90%", xs: "90%" },
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              overflow: "auto",
              maxHeight: "95%",
              maxWidth: "400px",
            }}
          >
            <div className="py-4 px-3  mb-4 flex justify-between items-center border-b">
              <span className="text-2xl font-bold">ارسال صورت حساب</span>
              <div></div>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xl">
                {" "}
                آیا از ارسال این صورت حساب اطمینان دارید ؟‌
              </span>
            </div>
            <div className="flex col-span-2 justify-between items-center mt-5">
              <Button
                sx={{ width: "8rem" }}
                variant="contained"
                onClick={handleCreate}
                color="primary"
                disabled={loading.create}
              >
                {loading.create ? (
                  <>
                    <CircularProgress size={20} />
                  </>
                ) : (
                  <>تایید</>
                )}
              </Button>{" "}
              <Button
                onClick={() => {
                  setOpen2(false);
                }}
                sx={{ width: "8rem", background: "#ccc" }}
                variant="contained"
                color="inherit"
              >
                انصرف
              </Button>
            </div>
          </Box>
        </Modal>
        <Modal open={open3} onClose={closeCopy}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { md: "90%", xs: "90%" },
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              overflow: "auto",
              maxHeight: "95%",
              maxWidth: "400px",
            }}
          >
            <div className="py-4 px-3  mb-4 flex justify-between items-center border-b">
              <span className="text-2xl font-bold">کپی صورت حساب</span>
              <div></div>
            </div>
            <div className="flex flex-col gap-3">
              <TextInput
                label="شماره فاکتور"
                onChange={(e) => setGetInvoiceIntSellDefaultValue(e)}
                value={getInvoiceIntSellDefaultValue}
              />
              <DateInput
                label={" تاریخ"}
                value={date}
                onChange={(e) => setDate(e)}
              />
            </div>
            <div className="flex col-span-2 justify-between items-center mt-5">
              <Button
                sx={{ width: "8rem" }}
                variant="contained"
                onClick={handleCopy}
                color="primary"
                disabled={loading.copy}
              >
                {loading.copy ? (
                  <>
                    <CircularProgress size={20} />
                  </>
                ) : (
                  <>تایید</>
                )}
              </Button>{" "}
              <Button
                onClick={closeCopy}
                sx={{ width: "8rem", background: "#ccc" }}
                variant="contained"
                color="inherit"
              >
                انصرف
              </Button>
            </div>
          </Box>
        </Modal>
        <Modal
          open={open4}
          onClose={() => {
            setOpen4(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { md: "90%", xs: "90%" },
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 2,
              borderRadius: 2,
              overflow: "auto",
              maxHeight: "95%",
              maxWidth: "400px",
            }}
          >
            <div className="py-4 px-3  mb-4 flex justify-between items-center border-b">
              <span className="text-2xl font-bold"> ایجاد صورتحساب اصلاحی</span>
              <div></div>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xl">
                {" "}
                آیا از ایجاد صورتحساب اصلاحی اطمینان دارید ؟‌
              </span>
            </div>
            <div className="flex col-span-2 justify-between items-center mt-5">
              <Button
                sx={{ width: "8rem" }}
                variant="contained"
                onClick={handleUpdate}
                color="primary"
                disabled={loading.update}
              >
                {loading.update ? (
                  <>
                    <CircularProgress size={20} />
                  </>
                ) : (
                  <>تایید</>
                )}
              </Button>{" "}
              <Button
                onClick={() => {
                  setOpen4(false);
                }}
                sx={{ width: "8rem", background: "#ccc" }}
                variant="contained"
                color="inherit"
              >
                انصرف
              </Button>
            </div>
          </Box>
        </Modal>
      </Paper>
      {data?.chLastWorkflowStepCode === "Initial" ||
      data?.chLastWorkflowStepCode === "Failed" ? (
        <Paper
          sx={{ zIndex: 9, position: "relative" }}
          className="mx-3 my-5 border py-3 px-3 relative z-50"
          elevation={1}
        >
          <div className="flex justify-center items-center gap-3">
            <IconButton>
              <DeleteIcon
                onClick={() => setRemoveConfirm(true)}
                color="error"
              />
            </IconButton>
          </div>
        </Paper>
      ) : (
        <></>
      )}
      <Modal
        open={removeConfirm}
        onClose={() => {
          setRemoveConfirm(false);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { md: "90%", xs: "90%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            overflow: "auto",
            maxHeight: "95%",
            maxWidth: "400px",
          }}
        >
          <div className="py-4 px-3  mb-4 flex justify-between items-center border-b">
            <span className="text-2xl font-bold"> حذف صورت حساب </span>
            <div></div>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-xl">
              {" "}
              آیا از حذف این صورت حساب اطمینان دارید‌
            </span>
          </div>
          <div className="flex col-span-2 justify-between items-center mt-5">
            <Button
              sx={{ width: "9rem" }}
              variant="contained"
              onClick={removeHandle}
              color="error"
            >
              {loading?.loadingRemove ? (
                <>
                  <CircularProgress size={20} />
                </>
              ) : (
                <> حذف </>
              )}
            </Button>{" "}
            <Button
              onClick={() => {
                setRemoveConfirm(false);
              }}
              sx={{ width: "9rem", background: "#ccc" }}
              variant="contained"
              color="inherit"
            >
              انصرف
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Details;
